const powersensorLogoURL = "https://images.squarespace-cdn.com/content/60349997e1c1c53c86d14309/1614060784230-NLCZD9D71B4GYW2MUQTA/Group+23.png?content-type=image%2Fpng"
const getUploadUrlEndpoint = 'https://nfcqfk3lnd.execute-api.ap-southeast-2.amazonaws.com/prod/upload';
const getPredictionEndpoint = 'https://nfcqfk3lnd.execute-api.ap-southeast-2.amazonaws.com/prod/predict';

export {
    powersensorLogoURL,
    getUploadUrlEndpoint,
    getPredictionEndpoint,
};
